import { render, staticRenderFns } from "./ConfirmResetPassword.vue?vue&type=template&id=0857d58a&scoped=true&"
import script from "./ConfirmResetPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmResetPassword.vue?vue&type=style&index=0&id=0857d58a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0857d58a",
  null
  
)

export default component.exports